export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CalificacionesParcialesPage.vue?vue&type=template&id=14f317ea&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/CalificacionesParcialesPage.vue?vue&type=template&id=14f317ea&scoped=true&
// module id = 600
// module chunks = 27